'use strict';

module.exports = function (ngModule) {
    ngModule.controller('inboundRespController', require('./inbound_resp'));
    ngModule.controller('inboundOrigCountryController', require('./inbound_orig_country'));
    ngModule.controller('inboundOrigController', require('./inbound_orig'));
    ngModule.controller('outboundRespCountryController', require('./outbound_resp_country'));
    ngModule.controller('outboundRespController', require('./outbound_resp'));
    ngModule.controller('outboundOrigController', require('./outbound_orig'));
    ngModule.controller('lateralRespController', require('./lateral_resp'));
    ngModule.controller('lateralOrigController', require('./lateral_orig'));
    ngModule.controller('lateralMapController', require('./lateral_map'));
    ngModule.controller('networkAssetsController', require('./network_assets'));
    ngModule.controller('servicesController', require('./services'));
    ngModule.controller('topJA3Controller', require('./top_ja3'));
}



/** WEBPACK FOOTER **
 ** ./src/pages/controllers/general_network/index.js
 **/